<div class="filtro-mapa" [style]="'--width:' + width + 'em;' ">
    <img src="assets/mapa/filtros/data.png" [alt]="'COMPONENTS.SHARED.DATE_PICKER.ICON_ALT' | transloco">
    
    <span *ngIf="!formularioFiltros.get('dataInicio')?.value" class="placeholder-label m-2">
        {{ 'COMPONENTS.SHARED.DATE_PICKER.PLACEHOLDER' | transloco }}
    </span>
    <mat-date-range-picker #picker></mat-date-range-picker>
    
    <mat-date-range-input *ngIf="formularioFiltros" [rangePicker]="picker" [formGroup]="formularioFiltros" [max]="dataMax">
        <input class="input-date" matStartDate formControlName="dataInicio" (dateChange)="atualizarDataMax()">
        <input class="input-date" matEndDate formControlName="dataFim" (dateChange)="emitirData()">
    </mat-date-range-input>

    <button class="campo-input" mat-button (click)="picker.open()"></button>
</div>